import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { UserSessionInterface } from '../../../interfaces/interfaces';

export const getUserSessionsTableColumns = (
  setSessionToDelete: (session: UserSessionInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setSessionToToggleActive: (session: UserSessionInterface) => void,
  setToggleActiveDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'userId', headerName: 'User ID', width: 100 },
  { field: 'sessionId', headerName: 'Session ID', width: 220 },
  { field: 'sessionIP', headerName: 'Session IP', width: 140 },
  { 
    field: 'sessionIPs', 
    headerName: 'Session IPs', 
    width: 180, 
    valueGetter: (params: { row?: UserSessionInterface }) =>
    params.row && Array.isArray(params.row.sessionIPs)
        ? params.row.sessionIPs.join(', ')
        : ''
},
  { field: 'token', headerName: 'Token', width: 220 },
  { field: 'active', headerName: 'Active', width: 80, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 180 },
  { field: 'updated_at', headerName: 'Updated', width: 180 },
  {
    field: 'toggleActive',
    headerName: 'Toggle Active',
    width: 130,
    renderCell: (params) => (
      <Button
        color={params.row.active ? 'warning' : 'success'}
        variant="outlined"
        size="small"
        onClick={() => {
          setSessionToToggleActive(params.row);
          setToggleActiveDialogOpen(true);
        }}
      >
        {params.row.active ? 'Deactivate' : 'Activate'}
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setSessionToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];